import { Box } from 'braid-design-system';

import { palette, transparent } from '#src/palette.ts';

export const Placeholder = ({
  width,
  height,
}: Pick<React.HTMLProps<HTMLDivElement>, 'width' | 'height'>) => (
  <Box
    position="relative"
    overflow="hidden"
    display="flex"
    alignItems="center"
    justifyContent="center"
    borderRadius={undefined}
    style={{
      border: `1px solid ${transparent.placeholderBorder}`,
      backgroundColor: transparent.placeholderFill,
      width,
      height,
    }}
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{
        position: 'absolute',
        width: '100%',
        height: '100%',
      }}
    >
      {/* https://github.com/seek-oss/scoobie/blob/248312d5c4677d60d82e2276fb3b5435fcf33b56/src/private/color.ts#L2-L3*/}
      <line
        style={{ strokeWidth: 2, stroke: palette.grey[300] }}
        x1="0"
        y1="0"
        x2="100%"
        y2="100%"
      />
      <line
        style={{ strokeWidth: 2, stroke: palette.grey[300] }}
        x1="100%"
        y1="0"
        x2="0"
        y2="100%"
      />
    </svg>
  </Box>
);
